/**
 * Add new tour's data here.
 *
 * Tour name should be the same as the page name, where you want this tour will be shown
 * Only one tour per one page
 *
 * */
export const tours = {
  // Should be the same name as page name, eg.: jumbomail.me/inbox <--
  inbox: {
    // Which element do you want to be highlighted
    ".inbox-menu": [],
    ".inbox-mails-container .inbox-list-mail:first-child .inbox-list-mail-container":
      [
        // Which element to act on
        { element: ".inbox-list-mail", actionName: "mouseout" },
      ],
    ".inbox-mails-container .inbox-list-mail:first-child": [
      { element: "#actions-component-wrapper", actionName: "mouseover" },
    ],
    ".search-bar": [
      { element: "#actions-component-wrapper", actionName: "mouseout" },
      { element: "#inbox-tour-step-3", actionName: "click" },
      { stepNumber: 4, element: ".select-list-icon", actionName: "click" },
    ],
    ".select-options-list": [
      { stepNumber: 4, element: ".select-list-icon", actionName: "click" },
    ],
  },
  "page-edit": {
    // Which element do you want to be highlighted
    ".right-edit-tour": [
      { element: ".right-edit-tour", actionName: "mouseout" },
      { element: ".back-button-tour-steps", actionName: "click" },
    ],
    ".add-logo-step1": [
      { element: ".add-logo-step1", actionName: "mouseout" },
      { element: ".exit-panel", actionName: "click" },
      { element: ".click-form-carousel-tour", actionName: "click" },
    ],
    ".step-2-embed-page": [
      { element: ".description", actionName: "mouseout" },
      { element: ".exit-panel", actionName: "click" },
      { element: ".click-form-carousel-tour", actionName: "click" },
    ],
    ".side-panel-step-4": [
      { element: ".side-panel-step-4", actionName: "mouseout" },
      { element: ".exit-panel", actionName: "click" },
      { element: ".click-form-carousel-tour", actionName: "click" },
    ],
    ".social-side": [
      { element: ".social-side", actionName: "mouseout" },
      { element: ".exit-panel", actionName: "click" },
      { element: ".click-form-carousel-tour", actionName: "click" },
    ],
    ".form-details": [
      { element: ".form-details", actionName: "mouseout" },
      { element: ".exit-panel", actionName: "click" },
      { element: ".click-form-carousel-tour", actionName: "click" },
    ],
    ".top-section": [
      // { element: ".type-forms", actionName: "click" },
      { element: ".top-section", actionName: "mouseout" },
      { element: ".click-form-carousel-tour", actionName: "click" },
    ],
  },
  "create-form": {
    ".tour-form": [
      { element: ".tour-form", actionName: "mouseout" },
      { element: ".tour-form", actionName: "click" },
    ],
    ".tour-settings": [
      { element: ".tour-settings", actionName: "mouseout" },
      { element: ".tour-settings", actionName: "click" },
    ],
    ".tour-publish": [
      { element: ".tour-publish", actionName: "mouseout" },
      { element: ".tour-publish", actionName: "click" },
    ],
    ".form-builder-content": [
      { element: ".form-builder-content", actionName: "mouseout" },
    ],
    ".preview-tour-step": [
      { element: ".preview-tour-step", actionName: "mouseout" },
      { element: ".tour-form", actionName: "click" },
    ],
    ".finish-form-tour-step": [
      { element: ".finish-form-tour-step", actionName: "mouseout" },
    ],
  },
};
